import { useState, useEffect } from 'react';

export function usePersistedState<T>(
  key: string,
  defaultValue: T,
  storage: Storage = sessionStorage
): [T, React.Dispatch<React.SetStateAction<T>>] {
  // Get the initial value from storage or use the default
  const [state, setState] = useState<T>(() => {
    try {
      const item = storage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
      console.error(`Error loading ${key} from storage:`, error);
      return defaultValue;
    }
  });

  // Update storage when state changes
  useEffect(() => {
    try {
      storage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.error(`Error saving ${key} to storage:`, error);
    }
  }, [key, state, storage]);

  return [state, setState];
}